/* udp-page.css */
:host {
    display: block;
  }
  